<script lang="ts">
  import Sidebar from "$lib/components/episodes/Sidebar.svelte";
  import MobileMenu from "$lib/components/episodes/MobileMenu.svelte";
  import { episodeDate } from "$lib/dates";
  import { colors, activeColor } from "$lib/data";
  import { get_pattern } from "$lib/utilities";
  import type { PageData } from "./$types";
  export let data: PageData;

  // Set our active section so our menu can be pretty
  import { activeSection } from "$lib/data";
  import { onMount } from "svelte";
  onMount(() => {
    $activeSection = "episodes";
  });

  let browserWidth: number;
</script>

<svelte:window bind:innerWidth={browserWidth} />
<main class="column">
  <article
    style="
            --primary: {colors[$activeColor].color};
            --secondary: {colors[$activeColor].highlight};
        "
  >
    {#if browserWidth > 1024}
      <header style:background-image={get_pattern()}>
        <h1>
          Episode #{data.episodeNumber}
        </h1>
        {#if data.episode.date}
          <time datetime={data.episode.date}>
            {episodeDate(data.episode.date)}
          </time>
        {/if}
      </header>
    {/if}

    <div class="body">
      {#if browserWidth > 1024}
        <Sidebar
          guest_host={data.episode.guest_host?.name !== undefined}
          guests={data.episode.guests?.length ?? 0}
          episodeNumber={data.episodeNumber ?? 0}
          galleryCount={data.galleryCount}
          videoCount={data.videoCount}
          bonusCount={data.bonusCount}
          achievementCount={data.achievementCount}
          in_revue={data.episode.in_revue}
        />
      {/if}
      <slot />
    </div>
  </article>
</main>
{#if browserWidth <= 1024}
  <MobileMenu
    guest_host={data.episode.guest_host?.name !== undefined}
    guests={data.episode.guests?.length ?? 0}
    episode={data.episode.episode_number ?? 0}
    episodeNumber={data.episodeNumber}
    galleryCount={data.galleryCount}
    videoCount={data.videoCount}
    achievementCount={data.achievementCount}
    bonusCount={data.bonusCount}
    in_revue={data.episode.in_revue ?? ""}
  />
{/if}

<style>
main {
  position: relative;
  z-index: 5;
  padding-top: 3rem;
  margin-bottom: 2rem;
}
main header {
  text-align: center;
  align-items: center;
  padding: 2rem;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  background: white;
  margin-bottom: 2rem;
  border-radius: 2rem;
  box-shadow: var(--shadow);
}
main header h1 {
  font-family: "Open Sans", sans-serif;
  color: transparent;
  font-weight: bold;
  -webkit-text-stroke-width: 2px;
  -webkit-text-stroke-color: var(--title);
  text-shadow: 2.5px 2.5px var(--primary);
  font-size: 3rem;
  margin: 0;
  vertical-align: middle;
}
main header time {
  font-family: "Open Sans", sans-serif;
  color: transparent;
  font-weight: bold;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: var(--title);
  text-shadow: 2px 2px var(--secondary);
  font-size: 2rem;
}

.body {
  display: flex;
}

@media (max-width: 1024px) {
  main {
    padding-top: 2rem;
    margin-bottom: 2rem;
  }
}
@media (max-width: 768px) {
  main {
    padding-top: 1rem;
    margin-bottom: 0;
  }
}
@media (max-width: 450px) {
  main {
    padding-top: 0rem;
  }
}
</style>
